// Module
var code = "<svg width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.955 8.31a.658.658 0 0 0-.93 0l-2.366 2.366V3.658a.658.658 0 1 0-1.315 0v7.018L6.979 8.31a.658.658 0 0 0-.93.93l3.487 3.488a.658.658 0 0 0 .93 0l3.489-3.488a.658.658 0 0 0 0-.93zm2.387 7.375H3.658a.658.658 0 1 0 0 1.315h12.684a.658.658 0 1 0 0-1.315z\"/></svg>";
// Exports
module.exports = code;